document.addEventListener("DOMContentLoaded", function() {

  const carousels = document.querySelectorAll('.custom-carousel');

  carousels.forEach(carousel => {
    initCarousel(carousel);
  });

  function initCarousel(carousel) {

    const realSlides = Array.from(carousel.querySelectorAll('.slide:not(.clone)'));
    const dots = Array.from(carousel.querySelectorAll('.dot'));

    if (realSlides.length <= 1) {
      const singleSlide = realSlides[0];
      if (singleSlide && singleSlide.dataset.slideLink) {

        singleSlide.addEventListener('click', (e) => {

          if (!e.target.closest('.slide-btn')) {
            window.location.href = singleSlide.dataset.slideLink;
          }
        });
      }

      dots.forEach(d => d.style.display = 'none');
      
      console.log('Carousel: Single slide detected. Navigation disabled.');
      return;
    }

    const slides = Array.from(carousel.querySelectorAll('.slide')); 
    const total  = slides.length - 1;
    let current  = 0;
    let timer    = null;

    const loopEnabled  = carousel.dataset.enableLoop === 'true'; 
    const intervalTime = parseInt(carousel.dataset.loopInterval, 10) || 5000;

    let didDrag = false;
    let touchStartX = 0;
    let touchStartY = 0; 
    const DRAG_THRESHOLD = 5; 

    slides.forEach(slide => {
      if (slide.dataset.slideLink) {
        slide.addEventListener('click', (e) => {
          if (didDrag || e.target.closest('.slide-btn')) {
            return;
          }
          window.location.href = slide.dataset.slideLink;
        });
      }
    });

    function goToSlide(idx) {
      if (idx < 0 || idx > total) return;
      const container = carousel.querySelector('.slides');
      container.style.transition = 'transform 0.5s ease-in-out';
      container.style.transform = `translateX(${-idx * 100}%)`;

      if (idx === total) {
        setTimeout(() => {
          container.style.transition = 'none';
          container.style.transform  = 'translateX(0%)';
          current = 0;
          updateDots(0);
          setTimeout(() => {
            container.style.transition = 'transform 0.5s ease-in-out';
          }, 50);
        }, 500);
      } else {
        updateDots(idx);
        current = idx;
      }
    }

    function updateDots(idx) {
      dots.forEach(d => d.classList.remove('active'));
      const realIdx = (idx === total) ? 0 : idx;
      if (dots[realIdx]) dots[realIdx].classList.add('active');
    }

    function nextSlide() {
      goToSlide(current === total ? 0 : current + 1);
    }

    function prevSlide() {
      if (current === 0) {
        const container = carousel.querySelector('.slides');
        container.style.transition = 'none';
        container.style.transform = `translateX(${-total * 100}%)`;
        void container.offsetWidth; 
        container.style.transition = 'transform 0.5s ease-in-out';
        current = total - 1;
        container.style.transform = `translateX(${-current * 100}%)`;
        updateDots(current);
      } else {
        goToSlide(current - 1);
      }
    }

    function pause() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function resume() {
      if (loopEnabled && !timer && realSlides.length > 1) {
        timer = setInterval(nextSlide, intervalTime);
      }
    }

    slides.forEach(s => s.addEventListener('dragstart', e => e.preventDefault()));

    dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        e.stopPropagation();
        pause();
        goToSlide(parseInt(dot.dataset.index, 10));
      });
    });

    carousel.addEventListener('mousedown', e => {
      didDrag = false;
      touchStartX = e.clientX;
      touchStartY = e.clientY; 
    });

    carousel.addEventListener('mousemove', e => {
      if (e.buttons === 1) {
        const deltaX = Math.abs(e.clientX - touchStartX);
        const deltaY = Math.abs(e.clientY - touchStartY);
        if (deltaX > DRAG_THRESHOLD && deltaY < deltaX * 2) {
          didDrag = true;
        }
      }
    });

    carousel.addEventListener('mouseup', e => {
      const deltaX = e.clientX - touchStartX;
      if (didDrag && Math.abs(deltaX) > DRAG_THRESHOLD) {
        if (deltaX < 0) nextSlide(); else prevSlide();
      }
      // 延迟重置 didDrag 确保不触发 click 事件
      setTimeout(() => { didDrag = false; }, 100);
    });

    carousel.addEventListener('touchstart', e => {
      didDrag = false;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, {passive: true});

    carousel.addEventListener('touchmove', e => {
      const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
      const deltaY = Math.abs(e.touches[0].clientY - touchStartY);
      if (deltaX > DRAG_THRESHOLD && deltaY < deltaX * 2) {
        didDrag = true;
      }
    }, {passive: true});

    carousel.addEventListener('touchend', e => {
      const deltaX = e.changedTouches[0].clientX - touchStartX;
      if (didDrag && Math.abs(deltaX) > DRAG_THRESHOLD) {
        if (deltaX < 0) nextSlide(); else prevSlide();
      }
      setTimeout(() => { didDrag = false; }, 100);
    });

    slides.concat(dots).forEach(el => {
      el.addEventListener('mouseenter', pause);
      el.addEventListener('mouseleave', resume);
    });

    resume();
  }
});